import React from 'react';
import { InvoiceForwardingRecordsQueryProvider } from './InvoiceForwardingRecordsQueryProvider';

export const InvoiceForwardingProviders = ({ children }: any) => {
	return <InvoiceForwardingRecordsQueryProvider>{children}</InvoiceForwardingRecordsQueryProvider>;
};
